// extracted by css-extract-rspack-plugin
export default {"visual":"FlexSuiteRiverStack-module__visual__xlL0_","mediaFrame":"FlexSuiteRiverStack-module__mediaFrame__zyx8F","dither":"FlexSuiteRiverStack-module__dither__ZZwuo"};